import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { translations } from '../locales/translations';
import { languages } from '../locales/languages';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    // Получаем сохраненный язык из localStorage или используем английский по умолчанию
    return localStorage.getItem('language') || 'en';
  });

  // Функция для перевода текста
  const t = useCallback((key, params = {}) => {
    const translation = translations[currentLanguage]?.[key] || translations.en[key] || key;
    
    // Заменяем параметры в переводе
    if (params && typeof params === 'object') {
      return Object.keys(params).reduce((str, param) => {
        return str.replace(new RegExp(`{${param}}`, 'g'), params[param]);
      }, translation);
    }
    
    return translation;
  }, [currentLanguage]);

  // Функция для смены языка
  const changeLanguage = (languageCode) => {
    if (translations[languageCode]) {
      setCurrentLanguage(languageCode);
      localStorage.setItem('language', languageCode);
      
      // Обновляем атрибут lang у html элемента
      document.documentElement.lang = languageCode;
    }
  };

  // Получаем текущий язык
  const getCurrentLanguage = () => {
    return languages.find(lang => lang.code === currentLanguage) || languages[0];
  };

  // Получаем все доступные языки
  const getAvailableLanguages = () => {
    return languages;
  };

  // Устанавливаем язык при инициализации
  useEffect(() => {
    document.documentElement.lang = currentLanguage;
  }, [currentLanguage]);

  const value = {
    currentLanguage,
    changeLanguage,
    t,
    getCurrentLanguage,
    getAvailableLanguages,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

// Хук для использования контекста переводов
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}; 